// import './assets/main.css';
// import './styles/main.scss';
// import './assets/css/portal_app_lb.css';

import { createApp } from 'vue';
import App from './App.vue';
// import router from './router';
import store from "@/store";
// import axios from 'axios';
import Utility from './common/UtilityFunctions.js';
// import $ from 'jquery';
import { createPortalRouter } from './routes.js';

import resize from './directives/resize.js';
import scroll from './directives/scroll.js';

/** **********************************************
 * Global settings and values
 *********************************************** */
import './CONSTANT';

/** **********************************************
 * Client side logging with Vue error handler
 *********************************************** */
import { errorHandler } from './common/errorLoggingService';

// /** **********************************************
//  * All other small helper functions, mainly jQuery events that is used across the site
//  *********************************************** */
import './common/accordion';
import './common/collapse';
import './common/hashScroll';
import './common/customerSupportModal';
import VueSelect from './components/UI/VueSelect.vue';
import { Field, Form } from 'vee-validate';
  
import { ObserveVisibility } from 'vue-observe-visibility';
import ValidationError from './components/UI/ValidationError.vue';
import RadioGroupInline from './components/Forms/New/RadioGroupInline.vue';
import RadioGroupStacked from './components/Forms/New/RadioGroupStacked.vue';
import Article from './components/Flows/Article.vue';
import Modal from './components/UI/Modal.vue';
import CprNumberField from './components/UI/CprNumberField.vue';
import BaseMomentDatePicker from '@/components/Forms/BaseMomentDatePicker.vue';
import LabelAndTooltip from '@/components/UI/LabelAndTooltip.vue';
import BaseFileField from '@/components/Forms/BaseFileField/BaseFileField.vue';
import BaseFileFieldAttachedFiles from '@/components/Forms/BaseFileField/BaseFileFieldAttachedFiles.vue';
import BaseFileFieldInput from '@/components/Forms/BaseFileField/BaseFileFieldInput.vue';
import { FocusTrap } from 'focus-trap-vue';

import '@/validators/validation';

const app = createApp(App);

app.component('BaseMomentDatePicker', BaseMomentDatePicker);
app.component('CprNumberField', CprNumberField);
app.component('Field', Field);
app.component('Form', Form);
app.component('RadioGroupInline', RadioGroupInline);
app.component('RadioGroupStacked', RadioGroupStacked);
app.component('ValidationError', ValidationError);
app.component('Article', Article);
app.component('VModal', Modal);
app.component('VueSelect', VueSelect);
app.component('LabelAndTooltip', LabelAndTooltip);
app.component('BaseFileField', BaseFileField);
app.component('BaseFileFieldAttachedFiles', BaseFileFieldAttachedFiles);
app.component('BaseFileFieldInput', BaseFileFieldInput);
app.component('FocusTrap', FocusTrap);

app.provide('$store', store);

const router : Router|null= createPortalRouter(window.location.pathname);
if(router != null) {
  app.provide('$route', router);
  app.provide('$router', router);
  app.use(router);
}
app.use(store);

app.directive('resize', resize);
app.directive('scroll', scroll);

app.directive('observe-visibility', ObserveVisibility);

const element = document.querySelector('#app');
if (element) {
  if (router === null) {
    app.mount('#app');
  } else {
    router.isReady().then(() => app.mount('#app'));
  }
}

$('body').addClass(Utility.getBrandFolderName());

// document.addEventListener('DOMContentLoaded', () => {
//   const app = createApp(App);
//   app.mount('#app');
// });

/** **********************************************
 * Error logging
 *********************************************** */
app.config.errorHandler = errorHandler;
